import ajaxUtil from "cy_static/ajaxUtil";
class HomepageService {
  accountSet(params) {
    return ajaxUtil.loadData('/pointgate/nmember/accountSet', params || {}).then(function (data) {
      let obj = {};
      if (data.respCode == '0000') {
        obj = (data.data && data.data.data) || {};
      }
      return obj;
    })
  }
  getPwdState(params) {
    return ajaxUtil.loadData('/pointgate/nmember/getPwdState', params || {}).then(function (data) {
      let obj = {};
      if (data.respCode == '0000') {
        obj = (data.data && data.data.data) || {};
      }
      return obj;
    })
  }
  statusBadge(params) {
    return ajaxUtil.loadData('/pointgate/orderCenter/statusBadge', params || {}).then(function (data) {
      if (data.respCode !== '0000') return {};
      return data.data;
    })
  }

  // 查询电子卷，优惠卷数量
  getMyCoupon(params) {
    return ajaxUtil.loadData('/pointgate/mall/myCoupon', params || {}).then(function (data) {
      if (data.respCode !== '0000') return {};
      return data.data;
    })
  }

  // 查询特定渠道号得优惠卷数量
  getMyCouponCountNum(params) {
    return ajaxUtil.loadData('/pointgate/mallCoupon/myCouponCountNum', params || {}).then(function (data) {
      if (data.respCode !== '0000') return {};
      return data.data;
    })
  }

  // 查询新电子券数据
  getPerformedEcardCount(params) {
    return ajaxUtil.loadData('/performed/perform/api/performQuery/performedEcardCount', params || {}).then(function (data) {
      if (data.respCode !== '0000') return {};
      return data.data;
    })
  }
}

export default new HomepageService();
